import { FetchBaseQueryError, createApi } from '@reduxjs/toolkit/query/react';
import InitialLoadingManager from '../../services/api/InitialLoadingManager';
import type { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { CompanyMenusData, Franchise, InitialDataResponseInterface } from '../../services/exports/Interfaces';
import { fakeBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import BackendApiClient from '../../services/api/BackendApiClient';

interface CompanyRequestDto {
  slug: string;
  hideLoading?: boolean;
}

export enum CompaniesApiSliceTags {
  Menus = 'Menus',
}

export const companiesApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'companiesApiSlice',
  tagTypes: Object.values(CompaniesApiSliceTags),
  endpoints: (build) => ({
    getFranchiseData: build.query<QueryReturnValue<Franchise, FetchBaseQueryError>, boolean | undefined>({
      queryFn: (hideLoading = false) =>
        InitialLoadingManager.getFranchiseData(hideLoading).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
    getCompanyData: build.query<InitialDataResponseInterface, CompanyRequestDto>({
      queryFn: ({ slug, hideLoading }) =>
        InitialLoadingManager.getCompanyData(slug, hideLoading).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
    }),
    getCompanyMenusData: build.query<CompanyMenusData, number>({
      queryFn: (companyId) =>
        BackendApiClient.request({
          method: 'GET',
          url: `/companies/${companyId}/menus`,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data?.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      providesTags: [CompaniesApiSliceTags.Menus],
    }),
  }),
});

export const {
  useGetFranchiseDataQuery,
  useLazyGetFranchiseDataQuery,
  useGetCompanyDataQuery,
  useGetCompanyMenusDataQuery,
  useLazyGetCompanyMenusDataQuery,
} = companiesApiSlice;
